import { connect } from 'react-redux';
import type { RootState } from 'src/store';
import type { GarmentMarkersType } from 'src/types/decorationSpecs';
import { getSceneDefiningBackgroundId, getBackgroundById, isEditingGarmentMarkers } from 'src/selectors/layers';
import { setGarmentMarkers } from 'src/pages/editor/components/backgrounds/slice';
import garmentMarkerOverlay from './garmentMarkerOverlay';

const mapStateToProps = (state: RootState) => {
    const backgroundId = getSceneDefiningBackgroundId(state);
    const background = backgroundId ? getBackgroundById(state, backgroundId) : undefined;

    if (!isEditingGarmentMarkers(state) || !background?.width || !background?.height) {
        return { backgroundId: undefined, markers: undefined };
    }

    return {
        backgroundId,
        // Pass the raw (possibly-undefined) Redux value through as-is, rather than substituting
        // `defaultMarkers(...)` here: that call allocates a brand-new object on every single store
        // update whenever garmentMarkers hasn't been calibrated yet, which defeats `connect`'s
        // shallow-equality check and forces this container to re-render on every unrelated Redux
        // action. `GarmentMarkerOverlay` derives the default (memoized on backgroundWidth/Height,
        // which are stable primitives) itself instead.
        markers: background.garmentMarkers,
        backgroundWidth: background.width,
        backgroundHeight: background.height,
    };
};

const mapDispatchToProps = { setGarmentMarkers };

const mergeProps = (
    { backgroundId, markers, backgroundWidth, backgroundHeight }: ReturnType<typeof mapStateToProps>,
    { setGarmentMarkers: dispatchSetGarmentMarkers }: typeof mapDispatchToProps,
    ownProps: {
        scale: number;
        offset: { x: number; y: number };
        canvasWidth: number;
        cursorChange: (cursor: string) => void;
    },
) => ({
    ...ownProps,
    markers,
    backgroundWidth,
    backgroundHeight,
    onChange: (newMarkers: GarmentMarkersType) => {
        if (backgroundId) {
            dispatchSetGarmentMarkers({ id: backgroundId, garmentMarkers: newMarkers });
        }
    },
});

const garmentMarkerOverlayContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(garmentMarkerOverlay);

export default garmentMarkerOverlayContainer;
